import type { OwnerInviteCreated, SiteUserDTO } from "@lumora/bridge";

/** Roles an admin may assign to non-primary site accounts. Single source for select + add form. */
export const SITE_ACCOUNT_ROLES = [
  "manager",
  "editor",
  "sales",
  "finance",
  "technician",
] as const;

export type SiteAccountRole = (typeof SITE_ACCOUNT_ROLES)[number];

export const DEFAULT_NEW_ACCOUNT_ROLE: SiteAccountRole = "manager";

/** Status line shown after a password reset request; names the recipient. */
export function resetStatusMessage(
  r: Pick<OwnerInviteCreated, "email" | "emailSent" | "inviteUrl">,
): string {
  return r.emailSent
    ? `Reset link emailed to ${r.email}.`
    : `Reset link for ${r.email} ready (email not sent — SMTP off): ${r.inviteUrl}`;
}

/** Pick the billing / Stripe owner row (flagged `primary`), if any. */
export function primaryAccount(users: SiteUserDTO[] | null): SiteUserDTO | null {
  return users?.find((u) => u.primary) ?? null;
}

export function formatCreated(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toISOString().slice(0, 10);
}
